var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62 22.556V12a4.004 4.004 0 0 0-4-4h-4V4a4.004 4.004 0 0 0-4-4H24a2.074 2.074 0 0 0-1.414.586l-14 14A2.072 2.072 0 0 0 8 16v6H4a4.004 4.004 0 0 0-4 4v34a4.004 4.004 0 0 0 4 4h56a4.004 4.004 0 0 0 4-4V26a3.987 3.987 0 0 0-2-3.444ZM58 12v10h-4V12ZM22.001 6.828 22.003 14h-7.175ZM12 18h10a4.004 4.004 0 0 0 4-4V4h24v18h-5a2 2 0 0 0-2 2v4H21v-4a2 2 0 0 0-2-2h-7Zm48 42H4V26h13v2a3.991 3.991 0 0 0 3.596 3.96c.75.077 22.059.077 22.808 0A3.991 3.991 0 0 0 47 28v-2h13Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.793 41.378-3.526-.512-1.578-3.194a3.018 3.018 0 0 0-5.378 0l-1.578 3.194-3.527.512a3.018 3.018 0 0 0-1.661 5.117l2.55 2.485-.6 3.51a3.018 3.018 0 0 0 4.352 3.163L32 53.996l3.154 1.657a3.018 3.018 0 0 0 4.352-3.162l-.602-3.51 2.551-2.486a3.017 3.017 0 0 0-1.662-5.117Zm-4.434 5.472a1.998 1.998 0 0 0-.575 1.77l.438 2.55-2.291-1.204a2.004 2.004 0 0 0-1.862 0l-2.29 1.204.437-2.55a1.998 1.998 0 0 0-.575-1.77l-1.853-1.805 2.56-.372a1.998 1.998 0 0 0 1.507-1.094L32 41.26l1.146 2.32a1.998 1.998 0 0 0 1.505 1.094l2.56.372Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 31,
    r: 2,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.21ebd5d60ad403a86392e5be4786c14e.svg";
export { ForwardRef as ReactComponent };